// John Eldhose 20200708
const AcademyPage = (page, parms) => ({
  type: 'ACADEMY_PAGE',
  page,
  parms
});

export default AcademyPage;



// WEBPACK FOOTER //
// ./src/actions/AcademyPage.js